export default IconYoga => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-yoga" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
  <path d="M4 20h4l1.5 -3" />
  <path d="M17 20l-1 -5h-5l1 -7" />
  <path d="M4 10l4 -1l4 -1l4 1.5l4 1.5" />
</svg>`;